<template>
  <b-row class="text-center">
     <div class="form-group col-lg-12 col-sm-12">
      <div class="input-group">
        <span class="input-group-btn">
          <b-button block variant="primary" @click.prevent="newAlumno">Nuevo Alumno</b-button>
        </span>
        <input type="text" v-model="filterText" class="form-control" @keyup.enter="doFilter" placeholder="Busque al alumno por apellido, nombre o dni" autofocus>
        <span class="input-group-btn">
          <button type="button" class="btn btn-primary"  @click.prevent="doFilter">Buscar</button>
          <button type="button" class="btn btn-primary"  @click.prevent="resetFilter">Reiniciar</button>          
        </span>          
      </div>
    </div>
    
  </b-row>
</template>

<script>
  export default {
    data () {
      return {
        filterText: '',        
      }
    },
    methods: {
      doFilter () {
        this.$events.fire('filter-set', this.filterText)
      },
      resetFilter () {
        this.filterText = ''
        this.$events.fire('filter-reset')
      },
      newAlumno () {
        console.log('nuevo alumno')
      },      
    }    
  }
</script>